export default __webpack_public_path__ + "static/pythonDev-56f523570d4ee8217032a4226f46496e.jpg";